import { USER_ROLES } from '@bagonboard/wiseman';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useRoleConditional from './useRoleConditional';

/**
 * Component to be able to hide and show components depending on the role of the current user
 *
 * @param {React.ReactNode} props.children
 * @param {ROLES[]} [[]] props.deny - Denied role array, mainly strategy
 * @param {ROLES[]} [[]] props.allow - Allowed role array
 * @returns {null | React.ReactNode}
 */
const RoleConditional = ({
  children, deny, allow, fallbackComponent: FallbackComponent,
}) => {
  const role = useRoleConditional();
  const isAllowed = useMemo(
    () => (deny.length > 0 ? role.notIncludes(deny) : role.includes(allow)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(deny), JSON.stringify(allow), role.value]
  );

  if (role.value && isAllowed) {
    return children;
  }

  return typeof FallbackComponent === 'function' ? <FallbackComponent /> : FallbackComponent;
};

RoleConditional.propTypes = {
  children         : PropTypes.node.isRequired,
  deny             : PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_ROLES))),
  allow            : PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_ROLES))),
  fallbackComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

RoleConditional.defaultProps = {
  deny             : [],
  allow            : [],
  fallbackComponent: null,
};

export default RoleConditional;
